var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.object)?_c('span',[_vm._v(_vm._s(_vm.locale == 'sl' 
    ? _vm.object.sl
    : _vm.object.en || (_vm.defaultToSl ? _vm.object.sl : '')))]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20ddb740","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/LocaleSpan.vue
// module id = null
// module chunks = 